import * as React from "react";
import { forwardRef } from "react";
const SvgPlusFillCircleIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 30 30", style: {
  enableBackground: "new 0 0 30 30"
}, xmlSpace: "preserve", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M15,0C6.7,0,0,6.7,0,15s6.7,15,15,15c8.3,0,15-6.7,15-15S23.3,0,15,0z M22.3,16H16v6.3h-2V16H7.7v-2H14V7.7h2V14h6.3V16z" }));
const ForwardRef = forwardRef(SvgPlusFillCircleIcon);
export { ForwardRef as ReactComponent };
